module.exports = __webpack_public_path__ + "img/green2.dac65af6.svg";